import _ from 'lodash'

import utility from '@/mixins/utility'

class Category {

  #data = {}

  #libraries = []

  constructor(data={})
  {  
    this.#data = data

    this.#libraries = utility.methods.mapModels(data.libraries, 'library')
  }

  /**
   * Property getters.
   */
  
  get active()
  {
    return this.#data.active
  }

  get color()
  {
    return this.#data.color
  }

  get description()
  {
    return this.#data.description
  }

  get icon()
  {
    return this.#data.icon
  }

  get id()
  {
    return this.#data.id
  }

  get name()
  {
    return this.#data.name
  }

  get slug()
  {
    return this.#data.slug
  }


  /**
   * Relationships.
   */

  get libraries()
  {
    return this.#libraries
  }

  /**
   * Computed properties.
   */
  
  get hasLibraries()
  {
    return this.libraries.length > 0
  }

  get sortedLibraries()
  {
    if( !this.hasLibraries )
      return []

    /**
     * @todo ordino per release date
     */
    return _.orderBy( this.libraries, ['updated_at'], ['desc'] )
  }
  
}

export default Category